import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ size = defaultSize, color = defaultIconColor, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round">
      <path d="M12 6v12" />
      <path strokeLinejoin="round" d="M7 13l5 5 5-5" />
    </g>
  </svg>
);
